// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactModal from "react-modal";
import * as SpotRequirementCmp$PorterinFeature from "./SpotRequirementCmp.mjs";
import * as BookingDetailsModuleScss from "@porterin/feature/src/ui/styles/common/BookingDetails.module.scss";

function SpotRequirementModal(Props) {
  var modal_state = Props.modal_state;
  var close_modal = Props.close_modal;
  var requirement = Props.requirement;
  var form = Props.form;
  var requirement_content = Props.requirement_content;
  return React.createElement(ReactModal, {
              isOpen: modal_state,
              onRequestClose: close_modal,
              closeTimeoutMS: 500,
              overlayClassName: BookingDetailsModuleScss.overlay,
              className: BookingDetailsModuleScss["modal-container"],
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: React.createElement(SpotRequirementCmp$PorterinFeature.make, {
                    requirement: requirement,
                    show_modal: close_modal,
                    form: form,
                    requirement_content: requirement_content
                  })
            });
}

var make = SpotRequirementModal;

export {
  make ,
}
/* react Not a pure module */
